import $ from 'jquery';
import * as stickyFill from './libs/stickyfill.es6';
import { Collapse } from 'bootstrap';
import { ClickOffHandler } from './utilities';
import fvSearch from './components/fv-search';
import brightcoveVideos from './components/brightcove-videos';
import expandableContent from './components/expandable-content';
import anchorScroll from './components/anchor-scroll';
import blogBanners from './components/blog-banners';
import hintimation from './components/hint-animation';
// import carousel from './components/carousels';
import JSFundFilters from './components/fund-filters';

window.jQuery = $;
window.$ = $;
window.Stickyfill = stickyFill;